/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Status_LabelInputs */

const vi_common_status_label = /** @type {(inputs: Common_Status_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trạng thái`)
};

/**

* @param {Common_Status_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const common_status_label = /** @type {((inputs?: Common_Status_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Status_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_common_status_label(inputs)
});